/**
 * OIDC Callback Component
 *
 * Shown while SpryAuthProvider processes the redirect from Keycloak.
 *
 * IMPORTANT: useSpryAccountManager() MUST be called here, even though the
 * account switcher UI isn't shown on this page.  When adding a second account,
 * the library's internal fa() effect detects spry_add_account_pending and
 * calls signinRedirect (with a proper state param) to complete the flow.
 * Without this call the callback page gets permanently stuck because the
 * initial soft-logout redirect arrives without a state param (Bs() = false)
 * so the oidc signinCallback is never triggered.
 */
import { useSpryAccountManager } from 'spry-apps-dropdown';

export function OidcCallback() {
  // Runs fa() — handles spry_add_account_pending → signinRedirect.
  useSpryAccountManager();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#121212',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
        <img
          src="/android-chrome-192x192.png"
          alt="SpryBoard"
          width={72}
          height={72}
          style={{ objectFit: 'contain', borderRadius: 16 }}
        />
        <div
          style={{
            width: 28,
            height: 28,
            border: '3px solid rgba(255,255,255,0.12)',
            borderTopColor: '#6965db',
            borderRadius: '50%',
            animation: 'spryboard-cb-spin 0.85s linear infinite',
          }}
        />
      </div>
      <style>{`
        @keyframes spryboard-cb-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
